var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{style:(_vm.strStyle)},[_vm._t("default"),_c('div',{staticStyle:{"height":"100px"}}),_c('flavour-buy-gin')],2)
}
var staticRenderFns = []

export { render, staticRenderFns }